<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import HeatmapMetric from "@/view/components/consumer_insights/HeatmapMetric.vue";
import {
  getAnalyticsPosMetric,
  getAnalyticsRegionMetric,
  getAnalyticsMinMaxDates
} from "@/api/analytics";
import { getLocationsItemByGroupId } from "@/api/locations";
import moment from "moment";
import metricsData from "@/data/metricsData.json";
const startOfMonth = moment()
  .clone()
  .startOf("month")
  .format("YYYY-MM-DD");
const endOfMonth = moment()
  .clone()
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "metrics-heatmap",
  components: {
    VueCtkDateTimePicker,
    HeatmapMetric
  },
  props: ["locations","location_groups"],
  data() {
    return {
      viewOptions: [
        { text: "Year Over Year", value: 1 },
        { text: "Year over 2 Years", value: 2}
      ],
      msg: null,
      loading: false,
      dtpicker: { start: startOfMonth, end: endOfMonth },
      dt: "",
      item: null,
      items: [],
      selectedLocations: [],
      selectedItems: [],
      selectedFilter: 1,
      snackbar: false,
      text: "",
      timeout: 2000,
      minDate: "",
      maxDate: "",
      searchTerm: null,
      locationsCopy: [],
      locationsOptions: [],
      maxDisplay: 1,
      swap: false,
      series: [],
      counter: 0,
      metrics: [metricsData[0], metricsData[1], metricsData[2], metricsData[3]],
      result: [],
      firstLoadDone: false,
      location_group: [],
      selectedLocationOrGroup: "locations",
      locationOrGroupOptions: [
        { text: "Locations", value: "locations"},
        { text: "Location Groups", value: "location_groups"}
      ],
      selectedLocationGroups: [],
      searchLocationGroupTerm: null,
      selectedLocationGroupItems: [],
      locationGroupsCopy: [],
      locationGroupsOptions: [],
      group_counter: 0,
      group_id: null,
      group_locations: [],
    };
  },
  async mounted() {
    this.firstLoadDatePick()
    let index = this.getIndex(this.locations);
    let selected = this.locations[index];
    this.selectedItems.push({
      value: selected.pos_id,
      text: `${selected.name} ${selected.full_address}`,
      name: selected.name,
      full_address: selected.full_address
    });
    let group_index = this.getIndex(this.location_groups);
    let selected_group = this.location_groups[group_index];
    this.location_group = {
      value: selected_group.id,
      text: `${selected_group.name}`,
      name: selected_group.name,
    };
    this.selectedLocationGroupItems.push(this.location_group);

    setTimeout(() => {
      this.setLocations();
      this.setLocationGroups();
    }, 2000);

    setTimeout(() => {
      // this.getAnalyticsMinMaxDates();
      this.onSearch();
    }, 1000);
  },
  computed: {
    likesAllItems() {
       return this.selectedItems.length === 30  || this.selectedItems.length == this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllGroupItems() { 
      return this.selectedLocationGroupItems.length === 30  || this.selectedLocationGroupItems.length === this.locationGroupsOptions.length;      
    },
    likesSomeGroupItem() {
      return this.selectedLocationGroupItems.length > 0 && !this.likesAllGroupItems;
    },
    groupicon() {
      if (this.likesAllGroupItems) return "mdi-close-box";
      if (this.likesSomeGroupItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    dtpicker(newVal) {
      if (newVal == undefined) {
        let last365 = moment().subtract(1, 'years')
        last365 = last365.format("YYYY-MM-DD");
        let today = moment()
        today = today.format("YYYY-MM-DD");

        this.dtpicker = { start: last365, end: today };
      }
    },
    "selectedItems"(){
      this.loading = false
      if (this.selectedItems.length > 30 && this.selectedLocationOrGroup != 'location_groups') {
        this.$nextTick(() => {
          this.selectedItems = [...this.selectedItems].slice(0, 30)
        })
        swal("Notice", "You've selected too many locations to analyze. Try creating a group of locations to analyze instead")
      }
    },
    "selectedLocationGroupItems"(){
      this.loading = false
      if (this.selectedLocationGroupItems.length > 30  && this.selectedLocationOrGroup != 'locations') {
        this.selectedLocationGroupItems = this.selectedLocationGroupItems.slice(0, 30)
        swal("Notice", "You've selected too many groups to analyze. Try by selecting fewer than 30 groups")
      }
    },
    "selectedLocationOrGroup"(){
      console.log(" selectedLocationOrGroup",this.selectedLocationOrGroup);
    }
  },
  methods: {
    setLocations() {
      this.locationsOptions = [
        ...this.locations.map(list => {
          return {
            value: list.pos_id,
            text: `${list.name.replace(list.full_address, '')}`,
            name: `${list.name.replace(list.full_address, '')}`,
            full_address: list.full_address
          };
        })
      ];
      this.locationsCopy = [...this.locationsOptions];
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item);
          }
          this.selectedItems = data;
        }
      });
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter(item => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchTerm = null
      this.filterLocations()
    },
    setLocationGroups() {
      this.locationGroupsOptions = [
        ...this.location_groups.map((list) => {
          return {
            value: list.id,
            text: `${list.name}`,
            name: list.name
          };
        }),
      ];
      this.locationGroupsCopy = [...this.locationGroupsOptions];
    },
    toggleLocationGroup() {
      this.$nextTick(() => {
        if (this.likesAllGroupItems) {
          this.selectedLocationGroupItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationGroupsOptions.length; i++) {
            let item = this.locationGroupsOptions[i];
            data.push(item);
          }
          this.selectedLocationGroupItems = data;
        }
      });
    },
    filterLocationGroups() {
      if (!this.searchLocationGroupTerm || this.locationGroupsOptions.length == 0) {
        this.locationGroupsOptions = this.locationGroupsCopy;
      }
      this.locationGroupsOptions = this.locationGroupsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchLocationGroupTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationGroupBlur(){
      this.searchLocationGroupTerm = null
      this.filterLocationGroups()
    },
    getIndex(obj) {
      return Math.floor(Math.random() * obj.length);
    },
    async getAnalyticsMinMaxDates() {
      const payload = ""; //this was the location of pos_id but object type, removing this
      //add new parameter for selected groups in getAnalyticsMinMaxDates
      if (this.selectedLocationOrGroup == 'locations'){
        const response = await getAnalyticsMinMaxDates(
          payload,
          this.selectedItems,
          [],
          'locations'
        );
        if (response) {
          this.minDate = response.min_date; // this set the limit of daterange in DT within avaiable date from pos_id
          this.maxDate = response.max_date;
        }
      } else if (this.selectedLocationOrGroup == 'location_groups'){
        const response = await getAnalyticsMinMaxDates(
          payload,
          [],
          this.selectedLocationGroupItems,
          'location_groups'
        );
        if (response) {
          this.minDate = response.min_date; // this set the limit of daterange in DT within avaiable date from pos_id
          this.maxDate = response.max_date;
        }
      }
    },
    onSearch() {
      this.counter = 0;
      this.group_counter = 0;
      this.loading = true;
      this.series = [];
      this.setupHeatmap();
    },
    async getGroupLocationData(group_locations){      
      for(let i=0; i < group_locations.count; i++){
        let item = group_locations.results[i];
        // console.log("response:",group_locations.count,group_locations.results);
        if (item) {
          let data = []
          let seriesObj ={}
          seriesObj.name = item.name;
          let payload = JSON.parse(
            JSON.stringify({
              pos_id: item.pos_id,
              start_date: this.dtpicker.start,
              end_date: this.dtpicker.end,
              period: "day"
            })
          );
          const responses = await Promise.all([
            getAnalyticsPosMetric(payload),
            getAnalyticsRegionMetric(payload)
          ]);
          let result1 = responses[0];
          let result2 = responses[1];
          this.result = [...result1, ...result2];
          // console.log("this.result", this.result);
          if (this.result && this.result.length > 0) {
            for (let i = 0; i < this.metrics.length; i++) {
              let baseline = this.metrics[i];
              data.push({ x: baseline.text, y: this.getData(baseline) });
            }
          } else {
            for (let i = 0; i < this.metrics.length; i++) {
              let baseline = this.metrics[i];
              data.push({ x: baseline.text, y: 0 });
            }
          }
          // Display to series
          seriesObj.data = data;
          this.series.push(seriesObj);          
        }
      }
    
      
      if (this.series.length > this.defaultRow) {
        let _diff = 0;
        _diff = this.series.length - this.defaultRow;
        // console.log("_diff", _diff);
        // console.log("plus height", _diff * this.plusHeight);
        this.defaultHeight = this.defaultHeight + _diff * this.plusHeight;
      }
        
      
    },
    async setupHeatmap() {
      let seriesObj = {};
      let data = [];
      if (this.selectedLocationOrGroup == 'locations'){
        if (this.counter !== this.selectedItems.length) {
          // console.log("counter", this.counter);
          // console.log("search");
          let item = this.selectedItems[this.counter];
          seriesObj.name = item.name;
          let payload = JSON.parse(
            JSON.stringify({
              pos_id: item.value,
              start_date: this.dtpicker.start,
              end_date: this.dtpicker.end,
              period: "day"
            })
          );

          const responses = await Promise.all([
            getAnalyticsPosMetric(payload),
            getAnalyticsRegionMetric(payload)
          ]);
          let result1 = responses[0];
          let result2 = responses[1];
          this.result = [...result1, ...result2];
          console.log("this.result", this.result);
          if (this.result && this.result.length > 0) {
            for (let i = 0; i < this.metrics.length; i++) {
              let baseline = this.metrics[i];
              data.push({ x: baseline.text, y: parseFloat(this.getData(baseline)).toFixed(2) });
            }
          } else {
            for (let i = 0; i < this.metrics.length; i++) {
              let baseline = this.metrics[i];
              data.push({ x: baseline.text, y: 0 });
            }
          }
          // Display to series
          seriesObj.data = data;
          this.series.push(seriesObj);
          this.counter = this.counter + 1;
          this.setupHeatmap();
        }

        if (this.counter == this.selectedItems.length) {
          this.loading = false;
          this.counter = 0;
        }
      }
      else if (this.selectedLocationOrGroup == 'location_groups'){
        if (this.group_counter !== this.selectedLocationGroupItems.length) {
          this.group_id = this.selectedLocationGroupItems[this.group_counter];
          this.counter = 0;
          console.log("Selected Group id:",this.group_id);
          this.group_locations = await getLocationsItemByGroupId(this.group_id.value);
          console.log("res:",this.group_locations,this.group_locations.count,this.group_locations.results[this.counter]);
          let res = await this.getGroupLocationData(this.group_locations);
          this.group_counter = this.group_counter+1;
          this.setupHeatmap();
        }
        if(this.group_counter == this.selectedLocationGroupItems.length){
          this.loading = false;
          this.isFinished = true;
          this.group_counter = 0;
        }
      }
    },
    getData(metric) {
      if(this.selectedFilter.value != null && this.selectedFilter.value == 2){
        let total = this.result
                .map(item => (item[metric.yo2y] ? parseFloat(item[metric.yo2y]) : 0))
                .reduce((x, y) => x + y);
        return total && !isNaN(total) ? total : 0;
      } else {
        let total = this.result
                .map(item => (item[metric.yoy] ? parseFloat(item[metric.yoy]) : 0))
                .reduce((x, y) => x + y);
        return total && !isNaN(total) ? total : 0;
      }

    },
    firstLoadDatePick(){
      if (!this.firstLoadDone ){ 
        this.firstLoadDone = true

        let current = new Date()
        let enddate = `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() + 1}-${current.getDate()}`
        
        this.dtpicker.start = startdate // this set the value of date picker //initial first load set date range
        this.dtpicker.end = enddate
      }
    },
    whenDtClosed(){
      if(this.dtpicker.end == null && this.dtpicker.start != null) {
        this.dtpicker.end = this.dtpicker.start
      }
    }
  }
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>

<template>
  <div id="kpi-heatmap" class="pb-40">
    <h3>HEATMAP</h3>
    <div
      class="mt-n10 py-2 py-lg-4 d-flex align-items-center justify-content-center"
    >
      <div class="mr-2" style="width: 250px;">
        <VueCtkDateTimePicker
          @is-hidden="whenDtClosed()"
          id="campaign-analytics-location-dtpicker"
          v-model="dtpicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select date range"
          :min-date="minDate"
          :max-date="maxDate"
          range
        />
      </div>
      <div class="mr-2 mt-6" style="width: 200px;">
        <v-select
                v-model="selectedFilter"
                :items="viewOptions"
                required
                dense
                outlined
                background-color="#ffffff"
                height="42"
                return-object
                @change="onSearch"
        ></v-select>
      </div>
      <div class="mr-2 mt-6" >
        <v-select
          v-model="selectedLocationOrGroup"
          :items="locationOrGroupOptions"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div>
      <div class="mr-2 mt-6" style="width: 300px;" v-if="selectedLocationOrGroup == 'locations'">
        <v-select
          v-if="selectedLocationOrGroup == 'locations'"
          v-model="selectedItems"
          :items="locationsOptions"
          multiple
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          label="Location"
          return-object
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="searchTerm"
                  placeholder="Search"
                  @input="filterLocations"
                  @blur="filterLocationsBlur"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
            <v-list-item ripple @click="toggle">
              <v-list-item-action>
                <v-icon
                  :color="selectedItems.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template
            v-if="selectedItems.length > 1"
            v-slot:selection="{ item, index }"
          >
            <span v-if="index === maxDisplay">
              {{ selectedItems.length }} locations selected
            </span>
          </template>
          <template slot="item" slot-scope="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.full_address }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </div>

      <div class="mr-2 mt-6" v-if="selectedLocationOrGroup == 'location_groups'">
        <v-select
          v-if="selectedLocationOrGroup == 'location_groups'"
          v-model="selectedLocationGroupItems"
          :items="locationGroupsOptions"
          label="Group Location"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          return-object
          style="position: relative; z-index: 4;"
          multiple
          :menu-props="{ top: false, offsetY: true }"
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="searchLocationGroupTerm"
                  placeholder="Search"
                  @input="filterLocationGroups"
                  @blur="filterLocationGroupBlur"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
            <v-list-item ripple @click="toggleLocationGroup">
              <v-list-item-action>
                <v-icon
                  :color="selectedLocationGroupItems.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ groupicon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template
            v-if="selectedLocationGroupItems.length > 1"
            v-slot:selection="{ item, index }"
          >
            <span v-if="index === maxDisplay">
              {{ selectedLocationGroupItems.length }} location groups selected
            </span>
          </template>
          <template slot="item" slot-scope="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
                <!-- <v-list-item-subtitle>
                  {{ item.full_address }}
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </div>

      <div>
        <v-btn
          depressed
          color="primary"
          @click="onSearch"
          :loading="loading"
          :disabled="loading"
          id="myBtn"
        >
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </div>
    </div>
    <v-alert outlined type="info" text class="outer-container">
      <span v-if="this.selectedFilter.value === 1 || this.selectedFilter === 1">These values are reported in year over year changes </span>
      <span v-if="this.selectedFilter.value === 2 || this.selectedFilter === 2">These values are reported in year over 2 year changes </span>
    </v-alert>
    <v-card flat class="mb-40">
      <v-overlay v-if="loading">
        <div class="text-center">
          <p>Loading locations</p>
          <v-progress-circular indeterminate size="30"></v-progress-circular>
        </div>
      </v-overlay>
      <div v-if="!loading">
        <heatmap-metric
          v-if="!loading && series.length > 0"
          :item="item"
          :series="series"
        ></heatmap-metric>
      </div>
    </v-card>
  </div>
</template>
